module.exports = __webpack_public_path__ + "static/img/pmw.a799c6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/pmw.png
// module id = k6Ic
// module chunks = 0